var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"bg-white focus:outline-none border border-gray-300 appearance-none",class:{ 'border-error': _vm.error },attrs:{"type":_vm.type},on:{"keyup":_vm.onChange}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }